/// <reference path="../../typings/tsd.d.ts" />
var warsApp;
(function (warsApp) {
    var models;
    (function (models) {
        var ObjectQueryRestrictionsModel = /** @class */ (function () {
            function ObjectQueryRestrictionsModel(scope, growlService, systemLevelService, applicationCodeService, treeService, objectQueryService) {
                this.scope = scope;
                this.growlService = growlService;
                this.systemLevelService = systemLevelService;
                this.applicationCodeService = applicationCodeService;
                this.treeService = treeService;
                this.objectQueryService = objectQueryService;
                this.isAndGroup = true;
                this.showPredicateHeader = false;
                var self = this;
                self.processConfigurationId = self.scope.processConfigurationId;
                self.objectQuery = self.scope.objectQuery;
                self.parentRestriction = self.scope.parentRestriction;
                self.topLevel = self.scope.topLevel;
                self.statuses = objectQueryService.getStatuses();
                self.states = objectQueryService.getStates();
                self.processTypes = objectQueryService.getProcessTypes();
                self.processSubTypes = objectQueryService.getProcessSubTypes();
                self.reviewConfigurations = objectQueryService.getReviewConfigurations();
                self.reviewTypes = objectQueryService.getReviewTypes();
                self.assignmentClaims = objectQueryService.getClaims();
                self.restrictions = self.getChildRestrictions(null);
                if (self.parentRestriction != null && self.parentRestriction.restrictionType === "D") {
                    self.isAndGroup = false;
                }
            }
            ObjectQueryRestrictionsModel.prototype.getChildRestrictions = function (restriction) {
                var self = this;
                self.showPredicateHeader = false;
                if (restriction == null) {
                    restriction = self.parentRestriction;
                }
                var l;
                if (restriction != null) {
                    l = Enumerable
                        .from(self.objectQuery.restrictions)
                        .where(function (i) { return i.parentRestriction_id === restriction.id; })
                        .toArray();
                }
                else {
                    l = Enumerable
                        .from(self.objectQuery.restrictions)
                        .where(function (i) { return i.myParentRestriction == null; })
                        .toArray();
                }
                for (var x = 0; x < l.length; x++) {
                    if (l[x].restrictionType === "P") {
                        self.showPredicateHeader = true;
                        self.loadCodes(l[x]);
                        l[x].states = self.objectQueryService.getStates();
                        l[x].statuses = self.objectQueryService.getStatuses();
                        l[x].processTypes = self.objectQueryService.getProcessTypes();
                        l[x].processSubTypes = self.objectQueryService.getProcessSubTypes();
                        l[x].reviewConfigurations = self.objectQueryService.getReviewConfigurations();
                        l[x].reviewTypes = self.objectQueryService.getReviewTypes();
                        l[x].assignmentClaims = self.objectQueryService.getClaims();
                        l[x].setValidValues(self.processConfigurationId != null);
                    }
                }
                return l;
            };
            ObjectQueryRestrictionsModel.prototype.addNewPredicate = function () {
                var self = this;
                self.objectQueryService.createNewPredicate(self.objectQuery, self.parentRestriction);
                self.restrictions = self.getChildRestrictions(null);
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.addNewAndGroup = function () {
                var self = this;
                self.objectQueryService.createNewAndGroup(self.objectQuery, self.parentRestriction);
                self.restrictions = self.getChildRestrictions(null);
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.addNewOrGroup = function () {
                var self = this;
                self.objectQueryService.createNewOrGroup(self.objectQuery, self.parentRestriction);
                self.restrictions = self.getChildRestrictions(null);
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.save = function (callback) {
                var self = this;
                self.objectQueryService.saveAllChanges(function () {
                    if (callback != null) {
                        callback();
                    }
                });
            };
            ObjectQueryRestrictionsModel.prototype.propertyTypeChange = function (predicate) {
                var self = this;
                var column;
                if (predicate.propertyType === 8 /* Assignment */ ||
                    predicate.propertyType === 9 /* ReviewInformation */ ||
                    predicate.propertyType === 6 /* StatusHistory */ ||
                    predicate.propertyType === 12 /* CommentInformation */) {
                    //initializers
                    column = predicate.getExtendedQueryColumn();
                    if (column == null) {
                        if (predicate.propertyType === 8 /* Assignment */) {
                            predicate.reportDataSubTableColumnName = "ClaimDefinitionUniqueIdentifier";
                            predicate.reportDataSubTableSystemColumnName = "SystemClaimGroupId";
                        }
                        if (predicate.propertyType === 9 /* ReviewInformation */) {
                            predicate.reportDataSubTableColumnName = "ReviewConfigurationUniqueId";
                            predicate.reportDataSubTableSystemColumnName = "SystemReviewGroupId";
                        }
                        if (predicate.propertyType === 6 /* StatusHistory */) {
                            predicate.reportDataSubTableColumnName = "ProcessLevelStatusUniqueIdentifier";
                            predicate.reportDataSubTableSystemColumnName = "SystemLevelStatusUniqueIdentifier";
                        }
                        if (predicate.propertyType === 12 /* CommentInformation */) {
                            predicate.reportDataSubTableColumnName = "ReviewConfigurationUniqueId";
                            predicate.reportDataSubTableSystemColumnName = "SystemReviewGroupId";
                        }
                        self.queryMapColumnChange(predicate);
                    }
                }
                else {
                    predicate.reportDataSubTableColumnName = null;
                    predicate.reportDataSubTableSystemColumnName = null;
                }
                if (predicate.propertyType !== 0 /* Property */) {
                    predicate.leftReportDataTreeItem = null;
                    if (predicate.propertyType === 8 /* Assignment */
                        || predicate.propertyType === 9 /* ReviewInformation */
                        || predicate.propertyType === 6 /* StatusHistory */
                        || predicate.propertyType === 12 /* CommentInformation */) {
                        column = predicate.getExtendedQueryColumn();
                        if (column.dataType !== models.ExtendedQueryColumnDataType.User
                            && column.dataType !== models.ExtendedQueryColumnDataType.UserEmail
                            && column.dataType !== models.ExtendedQueryColumnDataType.Date) {
                            predicate.rightParameterTreeItem = null;
                        }
                    }
                    else {
                        if (predicate.propertyType !== 17 /* StateLastUpdatedBy */ &&
                            predicate.propertyType !== 15 /* StatusLastUpdatedBy */ &&
                            predicate.propertyType !== 18 /* StateLastUpdatedDate */ &&
                            predicate.propertyType !== 16 /* StatusLastUpdatedDate */) {
                            predicate.rightParameterTreeItem = null;
                        }
                        else {
                            if (predicate.rightRestrictionType !==
                                5 /* PlaceHolder */) {
                                if (predicate.propertyType !== 18 /* StateLastUpdatedDate */ &&
                                    predicate.propertyType !== 16 /* StatusLastUpdatedDate */) {
                                    predicate.rightParameterTreeItem = null;
                                }
                            }
                        }
                    }
                    predicate.codeValueUniqueIdentifier = null;
                    if (predicate.propertyType === 3 /* RowId */ || predicate.propertyType === 10 /* ProcessId */) {
                        if (predicate.operatorType !== 11 /* In */
                            && predicate.operatorType !== 12 /* NotIn */) {
                            predicate.operatorType = 11 /* In */;
                        }
                        predicate.rightRestrictionType = 7 /* SubQuery */;
                    }
                    else {
                        if (predicate.operatorType !== 11 /* In */
                            && predicate.operatorType !== 12 /* NotIn */
                            && predicate.operatorType !== 0 /* Equals */
                            && predicate.operatorType !== 1 /* NotEqual */) {
                            if (predicate.rightRestrictionType !== 8 /* Calculation */) {
                                if (predicate.propertyType !== 18 /* StateLastUpdatedDate */ &&
                                    predicate.propertyType !== 16 /* StatusLastUpdatedDate */) {
                                    var reset = true;
                                    if (predicate.propertyType === 12 /* CommentInformation */) {
                                        column = predicate.getExtendedQueryColumn();
                                        if (column.dataType === models.ExtendedQueryColumnDataType.String) {
                                            reset = false;
                                        }
                                    }
                                    if (reset) {
                                        predicate.operatorType = 0 /* Equals */;
                                        predicate.rightRestrictionType = 1 /* InputParameterValue */;
                                    }
                                }
                            }
                        }
                        if (predicate.rightRestrictionType !== 1 /* InputParameterValue */
                            && predicate.rightRestrictionType !== 2 /* InputParameterList */
                            && predicate.rightRestrictionType !== 6 /* Value */
                            && predicate.rightRestrictionType !== 7 /* SubQuery */) {
                            if (predicate.propertyType === 9 /* ReviewInformation */ ||
                                predicate.propertyType === 8 /* Assignment */ ||
                                predicate.propertyType === 6 /* StatusHistory */ ||
                                predicate.propertyType === 12 /* CommentInformation */) {
                                if (column.dataType !== models.ExtendedQueryColumnDataType.User
                                    && column.dataType !== models.ExtendedQueryColumnDataType.UserEmail
                                    && column.dataType !== models.ExtendedQueryColumnDataType.Date) {
                                    predicate.operatorType = 0 /* Equals */;
                                    predicate.rightRestrictionType = 1 /* InputParameterValue */;
                                }
                            }
                            else {
                                if (predicate.propertyType === 17 /* StateLastUpdatedBy */ ||
                                    predicate.propertyType === 15 /* StatusLastUpdatedBy */) {
                                    if (predicate.rightRestrictionType !== 5 /* PlaceHolder */ ||
                                        (predicate.operatorType !== 0 /* Equals */ &&
                                            predicate.operatorType !== 1 /* NotEqual */)) {
                                        predicate.operatorType = 0 /* Equals */;
                                        predicate.rightRestrictionType = 1 /* InputParameterValue */;
                                    }
                                }
                                else if (predicate.propertyType !== 18 /* StateLastUpdatedDate */ &&
                                    predicate.propertyType !== 16 /* StatusLastUpdatedDate */) {
                                    predicate.operatorType = 0 /* Equals */;
                                    predicate.rightRestrictionType = 1 /* InputParameterValue */;
                                }
                            }
                        }
                    }
                    if (predicate.rightRestrictionType === 6 /* Value */) {
                        if ((predicate.propertyType === 1 /* State */ || (column != null && column.dataType === models.ExtendedQueryColumnDataType.State))
                            && predicate.stateUniqueIdentifier == null) {
                            predicate.stateUniqueIdentifier = self.states[0].value;
                        }
                        if ((predicate.propertyType === 2 /* Status */ || (column != null && column.dataType === models.ExtendedQueryColumnDataType.Status))
                            && predicate.statusUniqueIdentifier == null) {
                            predicate.statusUniqueIdentifier = self.statuses[0].value;
                        }
                        if (predicate.propertyType === 4 /* ProcessType */ && predicate.processType_id == null) {
                            predicate.processType_id = self.processTypes[0].value;
                        }
                        if (predicate.propertyType === 11 /* ProcessSubType */ && predicate.processSubType_id == null) {
                            predicate.processSubType_id = self.processSubTypes[0].value;
                        }
                        if (column != null && column.dataType === models.ExtendedQueryColumnDataType.ReviewConfiguration && predicate.reviewConfigurationIdentifier == null) {
                            predicate.reviewConfigurationIdentifier = self.reviewConfigurations[0].value;
                        }
                        if (column != null && column.dataType === models.ExtendedQueryColumnDataType.ReviewType && predicate.reviewTypeIdentifier == null) {
                            predicate.reviewTypeIdentifier = self.reviewTypes[0].value;
                        }
                        if (column != null && column.dataType === models.ExtendedQueryColumnDataType.Claim && predicate.assignmentClaimIdentifier == null) {
                            predicate.assignmentClaimIdentifier = self.assignmentClaims[0].value;
                        }
                    }
                    predicate.setValidValues(self.processConfigurationId != null);
                }
                else {
                    predicate.showValueTarget = false;
                    predicate.showParameterName = false;
                    predicate.showParameterTarget = false;
                }
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.booleanValueChange = function (predicate) {
                var self = this;
                if (predicate.transientBooleanValue === "1") {
                    predicate.booleanValue = true;
                }
                else {
                    predicate.booleanValue = false;
                }
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.queryMapColumnChange = function (predicate) {
                var self = this;
                self.objectQueryService.onObjectQueryModified(predicate.myObjectQuery);
                var column = predicate.getExtendedQueryColumn();
                predicate.reportDataSubTableSystemColumnName = column.systemColumn;
                predicate.operatorType = 0 /* Equals */;
                predicate.rightRestrictionType = 1 /* InputParameterValue */;
                predicate.onLeftPredicateChange(self.processConfigurationId != null);
                if (predicate.stateChange === models.ObjectQueryPredicateStateChange.LeftPredicate) {
                    self.save(null);
                    predicate.stateChange = models.ObjectQueryPredicateStateChange.LeftPredicate;
                }
            };
            ObjectQueryRestrictionsModel.prototype.operatorChange = function (predicate) {
                var self = this;
                predicate.onOperatorChange(self.processConfigurationId != null);
                if (predicate.stateChange === models.ObjectQueryPredicateStateChange.Operator) {
                    self.save(null);
                    predicate.stateChange = models.ObjectQueryPredicateStateChange.LeftPredicate;
                }
            };
            ObjectQueryRestrictionsModel.prototype.restrictionTypeChange = function (predicate) {
                var self = this;
                if (predicate.propertyType === 8 /* Assignment */
                    || predicate.propertyType === 9 /* ReviewInformation */
                    || predicate.propertyType === 12 /* CommentInformation */) {
                    var column = predicate.getExtendedQueryColumn();
                    if (column != null && column.dataType === models.ExtendedQueryColumnDataType.ReviewConfiguration && predicate.reviewConfigurationIdentifier == null) {
                        predicate.reviewConfigurationIdentifier = self.reviewConfigurations[0].value;
                    }
                    if (column != null && column.dataType === models.ExtendedQueryColumnDataType.ReviewType && predicate.reviewTypeIdentifier == null) {
                        predicate.reviewTypeIdentifier = self.reviewTypes[0].value;
                    }
                    if (column != null && column.dataType === models.ExtendedQueryColumnDataType.Claim && predicate.assignmentClaimIdentifier == null) {
                        predicate.assignmentClaimIdentifier = self.assignmentClaims[0].value;
                    }
                }
                if (predicate.propertyType === 0 /* Property */) {
                    predicate.onRightRestrictionTypeChange(self.processConfigurationId != null);
                    if (predicate.rightRestrictionType === 6 /* Value */) {
                        if (predicate.codeValueUniqueIdentifier == null) {
                            if (predicate.codes != null && predicate.codes.length > 0) {
                                predicate.codeValueUniqueIdentifier = predicate.codes[0].uniqueIdentifier;
                            }
                        }
                    }
                    if (predicate.stateChange === models.ObjectQueryPredicateStateChange.RightRistrictionType) {
                        self.save(null);
                        predicate.stateChange = models.ObjectQueryPredicateStateChange.LeftPredicate;
                    }
                }
                else {
                    predicate.onRightRestrictionTypeChange(self.processConfigurationId != null);
                    self.save(null);
                }
            };
            ObjectQueryRestrictionsModel.prototype.deleteRestriction = function (restriction) {
                var self = this;
                self.cascadeDeleteRestriction(restriction);
                self.save(function () {
                    self.restrictions = self.getChildRestrictions(null);
                });
            };
            ObjectQueryRestrictionsModel.prototype.onDragOverRestrictionProperty = function ($event, restriction) {
                //TODO - Remove if not needed
            };
            ObjectQueryRestrictionsModel.prototype.onDropRestrictionProperty = function ($event, restriction) {
                var self = this;
                var droppedTreeItem = self.treeService.getTreeConfigurationItem();
                //only report source (indexed form feilds and variables) are valid for left side restrictions
                if (droppedTreeItem.treeItemSource !== 6 /* FormField */
                    && droppedTreeItem.treeItemSource !== 10 /* Variable */) {
                    self.growlService.error("Only a form field or system variable can be dropped here.");
                    return;
                }
                //if (droppedTreeItem.variableType === Wars.Domain.Model.Codes.Enums.VariableType.ProcessId) {
                //    var apis = self.getApiActions(restriction);
                //    if (apis == null || apis.length === 0) {
                //        self.growlService.error("A process ID field requires a valid API object query configuration.");
                //        return;
                //    } 
                //}
                var treeItem = self.treeService.createTreeItemFromItemDropped();
                restriction.leftReportDataTreeItem = treeItem;
                self.objectQueryService.onObjectQueryModified(restriction.myObjectQuery);
                self.loadCodes(restriction);
                if (droppedTreeItem.variableType === 31 /* ProcessId */) {
                    restriction.rightRestrictionType = 7 /* SubQuery */;
                    restriction.operatorType = 11 /* In */;
                    var api = self.getApiActions(restriction)[0];
                    restriction.apiAction_id = api.id;
                    restriction.apiActionProcessType_id = api.processTypeId;
                }
                else {
                    restriction.apiAction_id = null;
                    restriction.apiActionProcessType_id = null;
                    restriction.onLeftPredicateChange(self.processConfigurationId != null);
                }
                if (restriction.stateChange === models.ObjectQueryPredicateStateChange.LeftPredicate) {
                    self.save(null);
                    restriction.stateChange = models.ObjectQueryPredicateStateChange.LeftPredicate;
                }
            };
            ObjectQueryRestrictionsModel.prototype.loadCodes = function (restriction) {
                var self = this;
                if (restriction.leftReportDataTreeItem === null)
                    return;
                if (restriction.leftReportDataTreeItem.schemaProperty === null)
                    return;
                if (restriction.leftReportDataTreeItem.schemaProperty.codeGroup_id === null)
                    return;
                var codeGroupId = restriction.leftReportDataTreeItem.schemaProperty.codeGroup_id;
                self.applicationCodeService.getApplicationCodesForConfiguration(codeGroupId, false).then(function (codes) {
                    restriction.codes = codes;
                });
            };
            ObjectQueryRestrictionsModel.prototype.setDefaultParameterName = function (restriction) {
                var self = this;
                var column;
                if (restriction.propertyType === 0 /* Property */) {
                    restriction.parameterName = self.getTreeItemName(restriction.leftReportDataTreeItem);
                }
                else if (restriction.propertyType === 5 /* ProcessInitiator */) {
                    restriction.parameterName = "[Process Initiator]";
                }
                else if (restriction.propertyType === 1 /* State */) {
                    restriction.parameterName = "[Current State]";
                }
                else if (restriction.propertyType === 17 /* StateLastUpdatedBy */) {
                    restriction.parameterName = "[Current State Updated By]";
                }
                else if (restriction.propertyType === 18 /* StateLastUpdatedDate */) {
                    restriction.parameterName = "[Current State Updated Date]";
                }
                else if (restriction.propertyType === 2 /* Status */) {
                    restriction.parameterName = "[Current Status]";
                }
                else if (restriction.propertyType === 15 /* StatusLastUpdatedBy */) {
                    restriction.parameterName = "[Current Status Updated By]";
                }
                else if (restriction.propertyType === 16 /* StatusLastUpdatedDate */) {
                    restriction.parameterName = "[Current Status Updated Date]";
                }
                else if (restriction.propertyType === 4 /* ProcessType */) {
                    restriction.parameterName = "[Process Type]";
                }
                else if (restriction.propertyType === 11 /* ProcessSubType */) {
                    restriction.parameterName = "[Process Sub-Type]";
                }
                else if (restriction.propertyType === 8 /* Assignment */) {
                    column = restriction.getExtendedQueryColumn();
                    restriction.parameterName = "[Assignmnet] [" + column.displayName + "]";
                }
                else if (restriction.propertyType === 9 /* ReviewInformation */) {
                    column = restriction.getExtendedQueryColumn();
                    restriction.parameterName = "[Review Information] [" + column.displayName + "]";
                }
                else if (restriction.propertyType === 6 /* StatusHistory */) {
                    column = restriction.getExtendedQueryColumn();
                    restriction.parameterName = "[Status History] [" + column.displayName + "]";
                }
                else if (restriction.propertyType === 12 /* CommentInformation */) {
                    column = restriction.getExtendedQueryColumn();
                    restriction.parameterName = "[Comment Information] [" + column.displayName + "]";
                }
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.getSubQueries = function (restriction) {
                var self = this;
                return Enumerable.from(self.objectQueryService.subQueries).where(function (i) { return i.id !== restriction.myObjectQuery.id; }).orderBy(function (i) { return i.name; }).toArray();
            };
            ObjectQueryRestrictionsModel.prototype.getProcessIdSubQueries = function (restriction) {
                var self = this;
                return Enumerable.from(self.objectQueryService.processIdSubQueries).where(function (i) { return i.id !== restriction.myObjectQuery.id; }).orderBy(function (i) { return i.name; }).toArray();
            };
            ObjectQueryRestrictionsModel.prototype.getApiActions = function (restriction) {
                var self = this;
                return self.objectQueryService.apiActions;
            };
            ObjectQueryRestrictionsModel.prototype.setApiAction = function (restriction) {
                var self = this;
                var apis = self.objectQueryService.apiActions;
                for (var i = 0; i < apis.length; i++) {
                    if (apis[i].id === restriction.apiAction_id) {
                        restriction.apiActionProcessType_id = apis[i].processTypeId;
                        break;
                    }
                }
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.onDragOverRestrictionParameter = function ($event, restriction) {
                //TODO - Remove if not needed
            };
            ObjectQueryRestrictionsModel.prototype.onDropRestrictionParameter = function ($event, restriction) {
                var self = this;
                var droppedTreeItem = self.treeService.getTreeConfigurationItem();
                if (restriction.rightRestrictionType === 3 /* Property */) {
                    //form or system variable
                    if (droppedTreeItem.treeItemSource !== 6 /* FormField */
                        && droppedTreeItem.treeItemSource !== 10 /* Variable */) {
                        self.growlService.error("Only a form field or system variable can be dropped here.");
                        return;
                    }
                }
                if (restriction.rightRestrictionType === 4 /* Constant */) {
                    //constant
                    if (droppedTreeItem.treeItemSource !== 3 /* Constant */) {
                        self.growlService.error("Only a constant can be dropped here.");
                        return;
                    }
                }
                if (restriction.rightRestrictionType === 5 /* PlaceHolder */) {
                    //place holder
                    if (droppedTreeItem.treeItemSource !== 11 /* PlaceHolder */) {
                        self.growlService.error("Only a place holder can be dropped here.");
                        return;
                    }
                }
                if (restriction.rightRestrictionType === 8 /* Calculation */) {
                    //place holder
                    if (droppedTreeItem.treeItemSource !== 0 /* Calculation */) {
                        self.growlService.error("Only a Calculation can be dropped here.");
                        return;
                    }
                }
                if (restriction.rightRestrictionType === 7 /* SubQuery */) {
                    //sub query
                    self.growlService.error("Only a object query can be dropped here.");
                    return;
                }
                var treeItem = self.treeService.createTreeItemFromItemDropped();
                if (restriction.propertyType === 0 /* Property */ &&
                    treeItem.variableType === 27 /* Claim */) {
                }
                else {
                    if (restriction.propertyType === 0 /* Property */) {
                        if (!((restriction.leftReportDataTreeItem.variableType === 4 /* Date */ ||
                            restriction.leftReportDataTreeItem.variableType === 3 /* DateTime */) &&
                            (treeItem.variableType === 4 /* Date */ ||
                                treeItem.variableType === 3 /* DateTime */))) {
                            if (restriction.leftReportDataTreeItem.variableType !== treeItem.variableType) {
                                self.growlService.error("The left and right side variable types are not the same.");
                                return;
                            }
                        }
                        //else if (restriction.leftReportDataTreeItem.variableType !== treeItem.variableType) {
                        //    self.growlService.error("The left and right side variable types are not the same.");
                        //    return;
                        //}    
                    }
                }
                if (restriction.propertyType === 8 /* Assignment */ ||
                    restriction.propertyType === 9 /* ReviewInformation */) {
                    var column = restriction.getExtendedQueryColumn();
                    if (column.dataType === models.ExtendedQueryColumnDataType.User) {
                        if (treeItem.variableType !== 10 /* User */) {
                            self.growlService.error("The only valid placeholders are those with a variable type User.");
                            return;
                        }
                    }
                }
                restriction.rightParameterTreeItem = treeItem;
                self.objectQueryService.onObjectQueryModified(restriction.myObjectQuery);
                restriction.codeValueUniqueIdentifier = null;
                restriction.parameterName = null;
                restriction.parameterSchemaPropertyUniqueId = null;
                restriction.apiAction_id = null;
                restriction.apiActionProcessType_id = null;
                self.save(null);
            };
            ObjectQueryRestrictionsModel.prototype.getTreeItemName = function (treeItem) {
                var self = this;
                var parentName = self.treeService.getParentDisplayName(treeItem);
                return parentName == null
                    ? "[" + self.treeService.getDisplayName(treeItem) + "]"
                    : "[" + parentName + "] [" + self.treeService.getDisplayName(treeItem) + "]";
            };
            ObjectQueryRestrictionsModel.prototype.cascadeDeleteRestriction = function (restriction) {
                var self = this;
                restriction.entityAspect.setDeleted();
                var childRestrictions = self.getChildRestrictions(restriction);
                if (childRestrictions.length > 0) {
                    for (var i = 0; i < childRestrictions.length; i++) {
                        self.cascadeDeleteRestriction(childRestrictions[i]);
                    }
                }
            };
            return ObjectQueryRestrictionsModel;
        }());
        models.ObjectQueryRestrictionsModel = ObjectQueryRestrictionsModel;
    })(models = warsApp.models || (warsApp.models = {}));
})(warsApp || (warsApp = {}));
